import React from 'react'
import logo from '../assets/logo-black.png'

const Footer = () => {
  const date = new Date()
  const year = date.getUTCFullYear()
  
  return (
    <footer className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white overflow-hidden">
      {/* Éléments décoratifs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-primary/10 to-red-600/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-gradient-to-tl from-red-500/10 to-primary/5 rounded-full blur-3xl"></div>
      
      <div className="relative">
        {/* Section principale du footer */}
        <div className="container mx-auto px-6 py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            
            {/* Logo et description */}
            <div className="md:col-span-2">
              <a href='#hero' className="flex items-center space-x-3 mb-6 group">
                <div className="relative">
                  <div className="absolute -inset-2 bg-gradient-to-r from-primary to-red-600 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                  <img src={logo} className="relative w-16 h-16 object-cover rounded-full shadow-lg" alt='ECKSD Logo'/>
                </div>
                <span className="text-3xl font-bold">
                  EC<span className='text-primary'>KSD</span>
                </span>
              </a>
              <p className="text-gray-300 leading-relaxed mb-6 max-w-md">
                École Ceyratoise de Karaté Self Défense
              </p>
              
              {/* Réseaux sociaux */}
              <div className="flex space-x-4">
                <a 
                  href="https://www.facebook.com/ecoleceyratoise.ecksd" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-white/10 hover:bg-blue-600 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
                  </svg>
                </a>
                <a 
                  href="https://www.instagram.com/ecksd_karate" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-white/10 hover:bg-pink-600 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                    <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
                  </svg>
                </a>
              </div>
            </div>
            
            {/* Navigation rapide */}
            <div>
              <h3 className="text-lg font-semibold mb-6 text-white">Navigation</h3>
              <ul className="space-y-3">
                {[
                  { href: "#cours", label: "Nos cours" },
                  { href: "#karate", label: "Équipe" },
                  { href: "#self", label: "Self-défense" },
                  { href: "#price", label: "Tarifs" },
                  { href: "#contact", label: "Contact" },
                ].map((link) => (
                  <li key={link.href}>
                    <a 
                      href={link.href} 
                      className="text-gray-300 hover:text-primary transition-colors duration-300 hover:translate-x-1 inline-block"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            
            {/* Informations de contact */}
            <div>
              <h3 className="text-lg font-semibold mb-6 text-white">Contact</h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-primary mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                  </svg>
                  <a href="mailto:ecolecksd@gmail.com" className="text-gray-300 hover:text-primary transition-colors duration-300">
                    ecolecksd@gmail.com
                  </a>
                </div>
                
                <div className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-primary mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  </svg>
                  <div className="text-gray-300">
                    <p>Gymnase du COSEC</p>
                    <p>8 rue de la paix, Ceyrat</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-primary mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  </svg>
                  <div className="text-gray-300">
                    <p>Artenium</p>
                    <p>4 parc de l'artière, Ceyrat</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Barre de copyright */}
        <div className="border-t border-gray-700">
          <div className="container mx-auto px-6 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="text-gray-400 text-sm">
                © {year} ECKSD - École Ceyratoise de Karaté Self Défense. Tous droits réservés.
              </div>
              <div className="flex items-center space-x-4 text-sm text-gray-400">
                <span>Développé par</span>
                <a 
                  href="https://sortidocorp.ovh" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary hover:text-red-400 transition-colors duration-300 font-medium"
                >
                  SortidoCorp
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer